import { render } from "./NextDelivery.vue?vue&type=template&id=d297af5c"
import script from "./NextDelivery.vue?vue&type=script&lang=js"
export * from "./NextDelivery.vue?vue&type=script&lang=js"

import "./NextDelivery.vue?vue&type=style&index=0&id=d297af5c&lang=scss"

import exportComponent from "/opt/approot/build.20241112-151327-1a92bd59/vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__